/**
 * O que faz: Identifica leads que já estão marcados como originados de anúncio.
 * Onde usa: Distribuição automática de leads, nos fluxos comuns e administrativos.
 * Conexões: Usa a marcação anuncio persistida pelo n8n nos leads recebidos.
 * Tabelas: Lê o campo leads.anuncio; não consulta nem altera o banco.
 * Data: 23/09/2026.
 */
export interface DadosOrigemLead {
  anuncio?: string | null;
}

export function leadVeioDeAnuncio(lead: DadosOrigemLead): boolean {
  // O n8n já persiste a marcação no campo anuncio; não inferimos anúncios pelo canal ou nome do criativo.
  return Boolean(lead.anuncio?.trim());
}
